import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" {...props}><path fill="none" d="M35.078 1.133L1.933 14.739l14.555 5.547 14.293 10.229 4.297-29.382z" /><path fill="none" d="M23.42 25.483l-7.214 5.137V20.234L35.438.668" /></svg>);